module.exports = {"data":{"meta":{"siteMetadata":{"title":"cloudThing - Develop | DevOps | Dynamics","description":"cloudThing solves complex business problems with Dynamics 365 and Bespoke Software from their offices in Birmingham, UK and Bangalore, India.","keywords":"develop devops dynamics"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 304
// module chunks = 60335399758886 114276838955818